import React from 'react';
import {
    List,
} from 'reactstrap';
import AsyncSelect from 'react-select/async';
import { debounce } from 'lodash-es';
import { httpClient } from '@s20/services/httpClient';
import CommonContext, { ApiRoutes, AppNavPaths } from '../Common';
import {
    AppPageForm, onFieldChange, onReactSelectChanged, toasty,
} from '../common/forms/FormElements';
import CustomCircularProgress from '../common/CustomCircularProgress';
import { Block, BlockBorder } from '../common/Block';
import { SaveButton } from '../common/forms/SaveButton';
import ValidatedSelect from '../common/forms/ValidatedSelect';
import { ExecutionHistory } from './common/ExecutionHistory';

class BaseMoveTimesheet {
    timesheetId = '';
}

class MoveTimesheetToJob extends React.Component {
    static contextType = CommonContext;

    constructor(props) {
        super(props);
        this.formRef = React.createRef();
        this.state = {
            formValidated: false,
            loading: false,
            saving: false,
            moveTimesheet: new BaseMoveTimesheet(),
            isValidated: false,
            timesheetOptions: [],
        };

        this.onChange = this.onChange.bind(this);
        this.onReactSelectChanged = onReactSelectChanged.bind(this);
    }

    onChange = onFieldChange;

    onSubmit = async () => {
        const { moveTimesheet } = { ...this.state };
        moveTimesheet.userId = this.context.user.employeeId;

        this.setState({ saving: true });

        try {
            await httpClient.post(ApiRoutes.adminTool.moveTimesheetToJob(), moveTimesheet);

            this.setState({
                moveTimesheet: new BaseMoveTimesheet(),
                isValidated: false,
                timesheetOptions: [],
            });

            toasty.success('Move Timesheet Succeed');

            // Refresh the table after successful submission
            await this.props.refreshUsageHistory();
        } catch (err) {
            console.error(err);
            toasty.error('Error: Move Timesheet Failed. Please Check Timesheet and Contract Number');
            await this.props.refreshUsageHistory();
        } finally {
            this.setState({ saving: false });
        }
    };

    loadTimesheetOptions = debounce((inputValue, callback) => {
        httpClient.js(ApiRoutes.typeAheads.timesheetNumberSearch(inputValue))
            .then((data) => {
                this.setState({ timesheetOptions: data });
                callback(data);
            });
    }, 250);

    render() {
        const {
            loading, saving, isValidated, moveTimesheet, timesheetOptions,
        } = this.state;

        if (loading) {
            return (
                <div className="confirmationContainer pt-2 d-flex flex-row align-items-center justify-content-center">
                    <CustomCircularProgress
                        color="secondary"
                        variant="indeterminate"
                        label={
                            this.props.match.params.id
                                ? 'Getting Tool History...'
                                : 'Loading form...'
                        }
                    />
                </div>
            );
        }

        if (!(this.context ?? {}).user) return null;

        return (
            <AppPageForm
                backUrl={AppNavPaths.AdminTool}
                backLabel="Back to Admin Tools"
                formShown={this.context.formIsOpen}
                formId="adminToolList"
                formName="adminToolList"
                formHeading="Move Timesheet To a New Job"
                formRef={this.formRef}
                formIsColumn
                saving={saving}
                isValidated={isValidated}
                onSubmit={this.onSubmit}
                setIsValidated={(value) => {
                    this.setState({ isValidated: value });
                }}
            >
                <Block padding="medium">
                    <div>
                        <ValidatedSelect
                            component={AsyncSelect}
                            label="Timesheet Number"
                            loadOptions={this.loadTimesheetOptions}
                            placeholder="Type Timesheet Number Here"
                            id="timesheetNumber"
                            name="moveTimesheet.timesheetId"
                            value={
                                (timesheetOptions ?? []).find((x) => x.value === moveTimesheet.timesheetId) ?? null
                            }
                            onChange={this.onReactSelectChanged}
                            cacheOptions
                            required
                            error="A timesheet number is required"
                        />

                        <BlockBorder />

                        <div className="d-flex justify-content-center">
                            <SaveButton
                                saving={saving}
                                label="Submit"
                            />
                        </div>
                    </div>
                </Block>

                <ExecutionHistory usageHistory={this.props.usageHistory}>
                    {(record) => (
                        <>
                            <div>
                                <strong>From:</strong>
                                <List type="unstyled">
                                    {record.input.from_TimesheetNumber && (
                                        <li>
                                            <strong>Timesheet:</strong>
                                            {' '}
                                            {record.input.from_TimesheetNumber}
                                        </li>
                                    )}
                                    {record.input.from_JobNumber && (
                                        <li>
                                            <strong>Job:</strong>
                                            {' '}
                                            {record.input.from_JobNumber}
                                        </li>
                                    )}
                                    {record.input.from_ContractName && (
                                        <li>
                                            <strong>Contract:</strong>
                                            {' '}
                                            {record.input.from_ContractName}
                                        </li>
                                    )}
                                </List>
                            </div>

                            <div>
                                <strong>To:</strong>
                                <List type="unstyled">
                                    {record.output.to_TimesheetNumber && (
                                        <li>
                                            <strong>Timesheet:</strong>
                                            {' '}
                                            {record.output.to_TimesheetNumber}
                                        </li>
                                    )}
                                    {record.output.to_JobNumber && (
                                        <li>
                                            <strong>Job:</strong>
                                            {' '}
                                            {record.output.to_JobNumber}
                                        </li>
                                    )}
                                    {record.output.to_ContractName && (
                                        <li>
                                            <strong>Contract:</strong>
                                            {' '}
                                            {record.output.to_ContractName}
                                        </li>
                                    )}
                                </List>
                            </div>
                        </>
                    )}
                </ExecutionHistory>
            </AppPageForm>
        );
    }
}

export default MoveTimesheetToJob;
